var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEncounters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.948,
    height: 19.557,
    viewBox: "0 0 20.948 19.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2494",
    "data-name": "Path 2494",
    d: "M13.632,21.007A7.185,7.185,0,0,0,0,24.156a7.083,7.083,0,0,0,.685,3.06L.013,30.581a.614.614,0,0,0,.721.722L4.14,30.63a7.059,7.059,0,0,0,1.421.5A8.4,8.4,0,0,1,13.632,21.007Z",
    transform: "translate(0 -16.996)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2495",
    "data-name": "Path 2495",
    d: "M175.163,155.222a7.141,7.141,0,0,0,.307-.757h-.022A7.168,7.168,0,0,0,169,145.011h0a7.159,7.159,0,1,0-.344,14.311,7.082,7.082,0,0,0,3.051-.685c3.731.738,3.44.685,3.526.685a.614.614,0,0,0,.6-.734Z",
    transform: "translate(-154.9 -139.766)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncounters);
export default __webpack_public_path__ + "static/media/encounters.96b97132aed4232fa9777fa87cf6a8ee.svg";
export { ForwardRef as ReactComponent };